import eventHub from 'apps/bankrate-events'

eventHub.$on('fieldChanged', payload => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    calcFieldName: payload.fieldName.toLowerCase(),
    calcFieldValue: payload.value.toLowerCase(),
    event: 'e_calcField'
  })
})

eventHub.$on('calculator:calculation', () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'e_calcComplete'
  })
})

eventHub.$on('calculator:requestRateTable', () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'e_calcRTRequest'
  })
})

eventHub.$on('calculator:engagement', clickText => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    calcCTAName: clickText.toLowerCase(),
    event: 'e_calcEngagement'
  })
})

// Add Tracking for CTA events outside the calculatorVue
let init = function init() {
  Array.prototype.forEach.call(
    document.querySelectorAll('[data-calculator-cta]'),
    function(item) {
      item.addEventListener('click', function(event) {
        let target = event.currentTarget
        let cta = target.getAttribute('data-calculator-cta')

        if (cta) {
          eventHub.$emit(cta, target.text)
        }
      })
    }
  )
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}

export default eventHub
